import script from "./psdReset.vue?vue&type=script&setup=true&lang=js"
export * from "./psdReset.vue?vue&type=script&setup=true&lang=js"

import "./psdReset.vue?vue&type=style&index=0&id=94615af2&lang=scss"

const __exports__ = script;

export default __exports__